import React, { useEffect, useState } from 'react';

const getHttpUrl = (value) => {
    if (typeof value !== 'string' || !value.trim()) {
        return null;
    }
    try {
        const url = new URL(value.trim());
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
    } catch {
        return null;
    }
};

const Newscomponent = ({ title, description, imgUrl, newsUrl, date, source = '' }) => {
    const [imageFailed, setImageFailed] = useState(false);
    const imageUrl = getHttpUrl(imgUrl);
    const articleUrl = getHttpUrl(newsUrl);
    const articleTitle = typeof title === 'string' && title.trim() ? title.trim() : 'Untitled article';
    const articleDescription = typeof description === 'string' ? description.trim() : '';
    const sourceName = typeof source === 'string' ? source.trim() : '';
    const publishedAt = date ? new Date(date) : null;
    const hasPublishedDate = publishedAt && Number.isFinite(publishedAt.getTime());

    useEffect(() => {
        setImageFailed(false);
    }, [imgUrl]);

    return (
        <article className="card news-card h-100">
            <div className="news-card-media">
                {imageUrl && !imageFailed ? (
                    <img
                        src={imageUrl}
                        className="card-img-top news-card-image"
                        alt=""
                        loading="lazy"
                        decoding="async"
                        onError={() => setImageFailed(true)}
                    />
                ) : (
                    <div className="news-image-placeholder">
                        <span className="news-image-placeholder-icon" aria-hidden="true"></span>
                        <span>Image unavailable</span>
                    </div>
                )}
            </div>
            <div className="card-body d-flex flex-column">
                <h2 className="card-title h5">{articleTitle}</h2>
                {articleDescription && <p className="card-text news-card-description">{articleDescription}</p>}
                <div className="news-card-footer mt-auto">
                    <p className="news-card-meta text-body-secondary">
                        <span className="news-card-source">{sourceName || 'Source unavailable'}</span>
                        <span>
                            {hasPublishedDate ? (
                                <>
                                    Published on{' '}
                                    <time dateTime={publishedAt.toISOString()}>
                                        {publishedAt.toLocaleString(undefined, {
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric',
                                            hour: 'numeric',
                                            minute: '2-digit',
                                            timeZoneName: 'short',
                                        })}
                                    </time>
                                </>
                            ) : 'Publication date unavailable'}
                        </span>
                    </p>
                    {articleUrl ? (
                        <a
                            href={articleUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-primary"
                            aria-label={`Read full article: ${articleTitle} (opens in a new tab)`}
                        >
                            Read More
                        </a>
                    ) : (
                        <span className="news-link-unavailable text-body-secondary">Article link unavailable</span>
                    )}
                </div>
            </div>
        </article>
    );
};

export default Newscomponent;
